import { LayerDefinition } from './types';

export const solarLunarDefinition: LayerDefinition = {
  id: 'solar_lunar_tools',
  name: 'Solar & Lunar Astronomical Tools',
  category: 'space_astronomy',
  categoryLabel: 'Astronomical & Ephemeris',
  icon: '☀️',
  description: 'Astronomical ephemeris calculator and visualization tools predicting solar azimuth, golden hour, blue hour, moon phases, illumination percentage, and galactic core alignment.',
  sourceModels: ['Astronomical Ephemeris Algorithms (SunCalc & MoonCalc)'],
  outputModels: ['Interactive ephemeris trajectories, galactic core tracking, and illumination curves']
};

export default solarLunarDefinition;
